import * as Long from "long";
import { selectPackageByNameType } from "../balancingSelectors/selectBalancingPackages";
import { selectBalancingShopOfferGroupByName } from "../balancingSelectors/selectBalancingPurchaseOfferGroups";
import { mapEventTypeToIdGroupOffer } from "../constants/IdGroupOffers";
import { IdLeagueGifts } from "../constants/IdLeagueGifts";
import { EventType, } from "../features/balancing/types/BalancingCore";
import { ReplacementLoca } from "../utils/i18n/ReplacementLoca";
import { utilNumber } from "../utils/utilNumber";
import { utilPackage } from "../utils/utilPackage";
import { selectCoopInfo } from "./selectCoopInfo";
import { selectTimesPurchasePackageAmount } from "./selectTimesPurchasePackageAmount";
import { selectTournamentDifficulty } from "./selectTournamentInfo";
export var selectIsGiftAlreadyPurchased = function (state, leagueId, giftType, leagueType) {
    var gift = selectGift(leagueId, giftType, leagueType);
    if (gift == undefined || gift.id == undefined) {
        return true;
    }
    if (!gift) {
        return false;
    }
    var maxPurchaseTime = Long.fromValue(gift.maxPurchases || 0);
    var currentPurchaseAmount = selectTimesPurchasePackageAmount(state, gift.id, giftType === IdLeagueGifts.LeaguePremiumOffer);
    return maxPurchaseTime.lessThanOrEqual(currentPurchaseAmount);
};
export var selectGift = function (league, giftType, leagueType) {
    return giftType === IdLeagueGifts.LeaguePremiumOffer
        ? selectOfferGift(league, leagueType)
        : selectRegularGift(league, giftType, leagueType);
};
export var selectRegularGift = function (league, giftType, leagueType) {
    var name = leagueType + giftType + (league + 1).toString();
    // TODO: clear this...
    // @ts-ignore
    return selectPackageByNameType(name, leagueType);
};
export var selectOfferGift = function (league, leagueType) {
    var packageType = mapEventTypeToIdGroupOffer.get(leagueType) || "";
    var balancingLeagueId = league + 1;
    var offerNumber = utilNumber.format(balancingLeagueId);
    if (balancingLeagueId < 10) {
        offerNumber = "0" + offerNumber;
    }
    var name = packageType.replace(ReplacementLoca.zero_0, offerNumber);
    var offerGroup = selectBalancingShopOfferGroupByName(name);
    if (offerGroup === undefined ||
        offerGroup.purchaseOffer === undefined ||
        offerGroup.purchaseOffer[0] === undefined) {
        return;
    }
    return {
        cost: [],
        id: offerGroup.purchaseOfferCharacteristicId,
        maxPurchases: offerGroup.maxPurchases,
        name: offerGroup.name,
        pictureReward: offerGroup.purchaseOffer[0].pictureReward,
        resourceReward: offerGroup.purchaseOffer[0].resourceReward,
    };
};
export var selectCurrentDialogGift = function (state) {
    return state.ongoingLeagueReward;
};
export var selectCurrentDialogGiftType = function (state) {
    return state.ongoingLeagueReward.leagueGiftType;
};
export var selectCurrentDialogGiftResourceData = function (state) {
    if (!state.ongoingLeagueReward || state.ongoingLeagueReward.id === -1) {
        return [];
    }
    return utilPackage.packageToDisplayableItems(state.ongoingLeagueReward);
};
export var selectIsTournamentGiftDialogDisabled = function (state) {
    var idEvent = state.ongoingLeagueReward.leagueType;
    var isCoopGift = idEvent === EventType.CoopLeague;
    if (isCoopGift && selectCoopInfo(state) === undefined) {
        return true;
    }
    var selectedGiftLevel = state.ongoingLeagueReward.giftLevel;
    var giftLevel = selectTournamentDifficulty(state, idEvent);
    if (giftLevel == undefined || giftLevel < 0) {
        giftLevel = 0;
    }
    return selectedGiftLevel > giftLevel;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectTournamentRewards.ts
// module id = 357
// module chunks = 3